import moment from 'moment';
import {
	getConfigValueDefaultingToTrue,
	getCurrency,
	getEntityById,
	getObjectValues,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
	Input,
	Select,
	DatePicker,
	Modal,
	Radio,
	Popover,
	Row,
	InputNumber,
	Spin,
	message,
} from 'antd';
import { normFile, imageUploadValidation, imageWildcardUploadAccept } from '../../utils/ImageUtils';
import BackButton from '../back_button/BackButton';
import OWButton from '../ow_button/OWButton';
import * as React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import ProblemTypeTreeSelect from '../problem_type_tree_select';

import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import { assetsRestReadThunk, assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import { SUB_ASSETS_TARGET_COLLECTION } from '../../reducers/assets_reducer';
import { spendCategoriesRestCrudThunksForBuyer } from '../../thunks/spend_categories_thunks';
import {
	problemTypesRestCrudThunksForBuyer,
	problemTypesHeirarchicalForBuyer,
} from '../../thunks/problem_types_thunks';
import { workOrderAttributesRestCrudThunksForBuyer } from '../../thunks/work_order_attributes_thunks';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesWithoutPMRestCrudThunksForBuyer,
} from '../../thunks/work_order_priorities_thunks';
import { workOrdersRestCrudThunksForBuyer } from '../../thunks/work_orders_thunks';
import {
	getDefaultFileListForImagesFromString,
	getProtectedImageUriForBuyer,
} from '../../utils/FileAccessUtils';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import {
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	supplierFacilitiesRestCrudThunksForBuyer,
} from '../../thunks/supplier_facilities_thunks';
import { suppliersRestCrudThunksForBuyer } from '../../thunks/suppliers_thunks';
import { buyersRestCrudThunksForBuyer } from '../../thunks/buyers_thunks';
import { areasRestCrudThunksForBuyer, fetchAreasWithHeirarchy } from '../../thunks/areas_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import SupplierSelectionWorkOrderSelect from '../supplier_selection_work_order_select';
import { InfoCircleOutlined } from '@ant-design/icons';
import { projectsRestCrudThunksForBuyer } from '../../thunks/projects_thunks';
import { debounce } from '../../utils/PerformanceUtils';
import { BUYER_ADMIN_ONLY, BUYER_STORE_ASSOCIATE } from '../roles/roles';
import _ from 'lodash';
import { getExchangeRate } from '../../thunks/currencies_thunks';
import { proposalsRestCrudThunksForBuyer } from '../../thunks/proposals_thunks';
import {
	getBuyerCompanyApprovalTiers,
	getProposalApprovalHierarchiesByAttributes,
	hasApprovalHierarchyChanged,
} from '../../thunks/company_approval_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import ApprovalHierarchyChangeModal from '../ApprovalHierarchyChangeModal';
import { resolutionTypesRestCrudThunksForBuyer } from '../../thunks/resolution_types_thunks';
import OWRichTextEditor from '../../rich_text_editor/OWRichTextEditor';
import OWUpload from '../OWUpload';
import { getBuyerCompanySettingValue } from '../../utils/AuthUtils';
import AssetWorkOrderSelect from '../asset_work_order_select/AssetWorkOrderSelect';
import SubAssetMultiSelect from '../sub_asset_multi_select/SubAssetMultiSelect';
import ClearErrors from '../clear_errors/ClearErrors';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import { NTE_LOCKED_STATUSES } from '../../constants/InvoiceStatuses';
import { invoicesRestCrudThunksForBuyer } from '../../thunks/invoices_thunks';
import WorkOrderIsPrivateFormItem from '../work_order_is_private_form_item/WorkOrderIsPrivateFormItem';
import { addBuyerSubscribersForBuyers } from '../../thunks/work_orders_subscribers_thunks';
import { getDueDate } from '../../utils/WorkOrderUtils';
import ResolvedImage from '../resolved_image/ResolvedImage';

const WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE = 'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE';
const WORK_ORDER_FORM_AREAS_AUTOCOMPLETE = 'WORK_ORDER_FORM_AREAS_AUTOCOMPLETE';
const WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE = 'WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE';
const WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE =
	'WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE';
const WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE =
	'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE';
const WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE = 'WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE';

interface WorkOrderSafeFormProps extends FormComponentProps {
	history: any;
	onSubmit: any;
	onCancel: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	isApprovalForm?: any;
	creating: boolean;
	updating: boolean;
	formData: any;
	createErrors: any[];
	updateErrors: any[];
	fetchMultipleLocations: any;
	fetchLocations: any;
	fetchLocation: any;
	locations: any;
	fetchBuyer: any;
	fetchMultipleAreas: any;
	fetchAreas: any;
	areas: any;
	fetchMultipleProblemTypes: any;
	fetchProblemTypes: any;
	problemTypes: any;
	fetchMultipleSpendCategories: any;
	fetchSpendCategories: any;
	spendCategories: any;
	fetchWorkOrderAttributes: any;
	fetchMultipleWorkOrderPriorities: any;
	fetchWorkOrderPriorities: any;
	workOrderPriorities: any;
	supplierFacilities: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	currentUser: any;
	updateWorkOrderForm: any;
	fetchSupplierFacility: any;
	fetchSupplierCompany: any;
	fetchMultipleProjects: any;
	fetchProjects: any;
	projects: any;
	buyerProjectIds: any;
	getQuotes: any;
	fetchApprovalHeirarchy: any;
	fetchExchangeRate: any;
	willApprovalHierarchyChange: any;
	getApprovalHierarchy: any;
	resolutionTypes: any;
	fetchMultipleResolutionTypes: any;
	fetchResolutionTypes: any;
	companyConfig: any;
	addBuyerSubscribers: any;
	getInvoiceCounts: any;
}

class WorkOrderEditSafeForm extends React.Component<WorkOrderSafeFormProps, any> {
	constructor(props) {
		super(props);
		this.state = {
			woChanges: {},
			assetId: nullSafeGet('assetId', this.props.formData),
			asset: nullSafeGet('asset', this.props.formData),
			areaId: null,
			problemTypeId: nullSafeGet('problemTypeId', this.props.formData),
			locationId: nullSafeGet('locationId', this.props.formData),
			previewVisible: false,
			uploadLoading: false,
			previewImage: false,
			privateSupplier: false,
			allPhotos: [],
			industryId: 1,
			isCapex: nullSafeGetOrElse('formData.isCapex', props, false),
			buyerProjectIds: [],
			supplierFacilityId: nullSafeGet('formData.supplierFacilityId', props),
			supplier: nullSafeGetOrElse('supplierFacility', this.props.formData, {}),
			location: nullSafeGetOrElse('location', this.props.formData, {}),
			userApprovalInfo: {},
			exchangeRate: nullSafeGetOrElse(
				'currencyExchangeRateLocationToSupplier',
				this.props.formData,
				1
			),
			currencyExchangeRateBuyerToLocation: nullSafeGetOrElse(
				'currencyExchangeRateBuyerToLocation',
				this.props.formData,
				1
			),
			currentNTE: nullSafeGetOrElse('formData.nte', props, 0),
			locationNTE: nullSafeGetOrElse(
				'formData.nteInLocationCurrency',
				props,
				nullSafeGet('formData.nte', props) /
					nullSafeGetOrElse('currencyExchangeRateLocationToSupplier', this.props.formData, 1)
			),
			hasQuote: false,
			currentApprovalHierarchy: {},
			buttonLoading: false,
			editorRef: React.createRef(),
			invoiceDisallowsNTE: false,
			isPrivate: nullSafeGetOrElse('isPrivate', this.props.formData, 0),
			isPrivateModalVisible: false,
			isPrivateLoading: false,
		};
	}
	confirmChange: any = () => {};
	cancelChange: any = () => {};

	buildPhotosInfo = (props) =>
		getDefaultFileListForImagesFromString(
			nullSafeGetOrElse('formData.images', props, []),
			ROLE_TYPES.BUYER,
			nullSafeGet('formData.convertedImages', props)
		);

	componentDidUpdate(prevProps) {
		// Conversions land seconds after the attachment does, so the work order can re-render with the
		// same images and a newly populated `convertedImages`.
		const imagesChanged = !_.isEqual(
			nullSafeGet('formData.images', prevProps),
			nullSafeGet('formData.images', this.props)
		);
		const convertedImagesChanged = !_.isEqual(
			nullSafeGet('formData.convertedImages', prevProps),
			nullSafeGet('formData.convertedImages', this.props)
		);
		if (imagesChanged || convertedImagesChanged) {
			this.setState({ allPhotos: this.buildPhotosInfo(this.props) });
		}
	}

	componentDidMount() {
		const {
			fetchExchangeRate,
			formData,
			fetchBuyer,
			currentUser,
			form,
			getQuotes,
			getApprovalHierarchy,
			getInvoiceCounts,
		} = this.props;
		const { location, supplier, locationNTE } = this.state;

		getInvoiceCounts({
			workOrderId: formData.id,
			statuses: NTE_LOCKED_STATUSES,
		}).then((count) => {
			this.setState({ invoiceDisallowsNTE: count > 0 });
		});

		getApprovalHierarchy({ isCapex: formData.isCapex, isPM: formData.isPM }).then((result) => {
			this.setState({ currentApprovalHierarchy: result }, () => this.configureNTEWarningMessage());
		});

		fetchBuyer(nullSafeGet('facility.buyerCompanyId', currentUser)).then((buyer) => {
			this.setState({ industryId: buyer.industryId });
		});

		if (formData.locationId) {
			this.setState({ locationId: formData.locationId });
		}

		if (formData.assetId) {
			this.setState({ assetId: formData.assetId });
		}

		if (formData.areaId) {
			this.setState({ areaId: formData.areaId });
		}

		if (formData.problemTypeId) {
			this.setState({ problemTypeId: formData.problemTypeId });
		}
		if (formData.isCapex) {
			this.setState({ isCapex: formData.isCapex });
		}
		if (formData.buyerProjectIds) {
			this.setState({ buyerProjectIds: formData.buyerProjectIds });
		}

		const photosInfo = this.buildPhotosInfo(this.props);
		this.setState({ allPhotos: photosInfo });

		getQuotes(
			{
				workOrderId: formData.id,
				supplierFacilityId: formData.supplierFacilityId,
			},
			'workOrderAssociatedQuotes'
		).then((proposals) => {
			if (proposals.length > 0) {
				this.setState({ hasQuote: true });
			} else {
				const locationCurrency = getCurrency({ location });
				const supplierCurrency = getCurrency({ supplier });
				const workOrderCurrency = getCurrency({ workOrder: formData });
				if (supplierCurrency && workOrderCurrency && workOrderCurrency.id !== supplierCurrency.id) {
					//Should only be possible if Suppliers Currency has changed
					fetchExchangeRate(
						supplierCurrency.id,
						workOrderCurrency.id,
						currentUser.contactType
					).then((rate) =>
						this.setState(
							{
								exchangeRate: nullSafeGetOrElse('conversionRate', rate, 1),
								currentNTE: locationNTE * nullSafeGetOrElse('conversionRate', rate, 1),
							},
							() => {
								form.setFieldsValue({
									nte: this.state.currentNTE,
									nteInLocationCurrency: locationNTE,
								});
							}
						)
					);
				}
			}
		});
	}

	configureNTEWarningMessage = () => {
		const { currentUser } = this.props;
		const { currentApprovalHierarchy, nextApprovalHierarchy } = this.state;
		const tiers = nullSafeGet('tierDetails', nextApprovalHierarchy || currentApprovalHierarchy);
		if (tiers && tiers.length > 0) {
			const userTier =
				_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) || tiers[0];
			this.setState({
				userApprovalInfo: { amount: userTier.amountUpto || 1000000000 },
			});
		}
	};

	getAdditionalInfo = () =>
		nullSafeGet('state.editorRef.current', this) &&
		(this.state.editorRef.current as any).getContent();

	handleSubmit = (e) => {
		const { form, formData, history, redirectForwardUrl, onSuccess, updateWorkOrderForm } =
			this.props;
		const {
			warranty,
			supplierFacilityId,
			exchangeRate,
			supplier,
			location,
			currentNTE,
			hasQuote,
			isCapex,
		} = this.state;

		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier });
		const workOrderCurrency = getCurrency({ workOrder: formData });

		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				// put image data into proper format to persist
				const picturesInfo = values.images.map((p) => {
					const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
					const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
					return `${fileId}/${fileName}`;
				});
				let workOrder = {
					...formData,
					id: values.id,
					title: values.title,
					status: values.status,
					areaId: values.areaId ? parseInt(values.areaId, 10) : undefined,
					problemTypeId: parseInt(values.problemTypeId, 10),
					woPriorityId: parseInt(values.workOrderPriorityId, 10),
					locationId: parseInt(values.locationId, 10),
					assetId: values.assetId ? parseInt(values.assetId, 10) : undefined,
					...(values.assetId && {
						isAssetDown: values.isAssetDown === 'true' ? true : false,
					}),
					// Only include subAssetIds when the picker would have been visible — i.e.
					// an asset is selected AND the loaded asset has sub-assets. Sending
					// `null` (or stale ids) when the picker is hidden would either erase
					// the existing association or attach ids belonging to a prior parent.
					...(values.assetId && nullSafeGetOrElse('subAssetCount', this.state.asset, 0) > 0
						? {
								subAssetIds:
									Array.isArray(values.subAssetIds) && values.subAssetIds.length > 0
										? values.subAssetIds.map((id) => parseInt(id, 10))
										: null,
						  }
						: {}),
					images: picturesInfo,
					isCapex: isCapex,
					dueDate: values.dueDate,
					nte: currentNTE !== null ? currentNTE : undefined,
					currencyId: !hasQuote ? supplierCurrency.id : workOrderCurrency.id,
					nteInLocationCurrency: values.nteInLocationCurrency
						? values.nteInLocationCurrency
						: undefined,
					locationCurrencyId: locationCurrency.id,
					currencyExchangeRateLocationToSupplier:
						locationCurrency.id === supplierCurrency.id ? 1 : exchangeRate,
					description: this.getAdditionalInfo(),
					buyerFacilityId: values.buyerFacilityId,
					buyerCompanyId: values.buyerCompanyId,
					createdBy: values.createdBy,
					supplierFacilityId: values.supplierFacilityId,
					contractorDetails: values.contractorDetails,
					notes: values.notes,
					poNumber: values.poNumber,
					buyerAttachments: values.buyerAttachments,
					supplierAttachments: values.supplierAttachments,
					buyerProjectIds: values.buyerProjectIds,
					isWarranty: values.isWarranty === 'true',
					resolutionTypeId: values.resolutionType,
				};

				updateWorkOrderForm(workOrder).then((record) => {
					if (redirectForwardUrl) {
						history.push(redirectForwardUrl);
					}
					if (onSuccess) {
						onSuccess(record);
					}
				});
			}
		});
	};

	handlePreview = (obj) => {
		let thumbUrl = null;
		let fullUrl = null;
		let photoInfo = null;
		if (obj.response.data) {
			const imgFileId = obj.response.data.fileId;
			const imgFileName = obj.response.data.fileName;
			// The list entry already carries the JPEG derivative's URL when the original was converted.
			fullUrl = obj.url || getProtectedImageUriForBuyer(imgFileId, imgFileName, 400, 400);
			thumbUrl = obj.thumbUrl || fullUrl;
			photoInfo = {
				uid: imgFileId,
				size: 1,
				name: obj.name || imgFileName,
				filename: obj.filename || imgFileName,
				url: fullUrl,
				status: 'done',
				thumbUrl: thumbUrl,
				response: { data: { fileName: imgFileName, fileId: imgFileId } },
				type: 'image/jpeg',
			};
		}

		this.setState({
			photoInfo: [photoInfo],
			previewImage: fullUrl || thumbUrl,
			previewVisible: true,
		});
	};

	handleCancel = () => this.setState({ previewVisible: false });

	handleImageUpdate = (info) => {
		if (info.file.status === 'done') {
			this.setState({ allPhotos: info.fileList });
		} else if (info.file.status === undefined) {
			info.fileList = this.state.allPhotos;
		}
	};

	isAreaFilterAllowed = () => {
		const { companyConfig, currentUser } = this.props;
		return getBuyerCompanySettingValue(ROLE_TYPES.BUYER)(
			'assetConfig.allowAreaAssociationWithAssets',
			companyConfig,
			currentUser,
			false
		);
	};

	handleLocationChange = (locationId) => {
		const { fetchLocation } = this.props;
		fetchLocation(locationId).then((loc) => {
			this.setState({ locationId: locationId, location: loc });
		});
	};

	handleAreaChange = (areaId) => {
		this.setState({ areaId: areaId });
	};

	handleProblemTypeChange = (problemTypeId) => {
		const { form } = this.props;
		this.confirmChange = () => {
			this.setState({ problemTypeId });
		};
		this.cancelChange = () => {
			form.setFieldsValue({ problemTypeId: this.state.problemTypeId });
		};
		this.changeApprovalHierarchyParamCheck({ problemTypeId: problemTypeId });
	};

	handleAssetChange = (assetId) => {
		const { fetchAsset, form } = this.props;
		form.setFieldsValue({ subAssetIds: [] });
		this.setState({ assetId });
		if (assetId && fetchAsset) {
			fetchAsset(assetId).then((asset) => this.setState({ asset }));
		} else {
			this.setState({ asset: undefined });
		}
	};

	calculateDueDate = () => {
		const { form, workOrderPriorities } = this.props;
		const woPriorityId = form.getFieldValue('workOrderPriorityId');
		const woPriority = getEntityById(woPriorityId, workOrderPriorities);
		const currentDueDate = form.getFieldValue('dueDate');
		return getDueDate(woPriority, currentDueDate);
	};

	handleSupplierFacilityChange = (supplierFacilityId) => {
		const { fetchSupplierFacility } = this.props;
		if (supplierFacilityId) {
			fetchSupplierFacility(supplierFacilityId).then((supplierFacility) => {
				supplierFacility.status === 'private'
					? this.setState({ privateSupplier: true })
					: this.setState({ privateSupplier: false });
			});
		}
	};

	handleAdditionalInfoChange = debounce(
		(additionalInfo) => {
			const { form } = this.props;
			form.setFieldsValue({ additionalInfo });
		},
		500,
		false
	);

	handleExpenseTypeChange = (e) => {
		const { isCapex } = this.state;
		if (e.target.value !== isCapex) {
			this.setState({ isCapex: e.target.value });
		}
	};

	toggleIsPrivate = () => {
		const { formData, currentUser, addBuyerSubscribers } = this.props;
		if (this.state.isPrivate) {
			this.setState({ isPrivateModalVisible: true });
		} else {
			const subscriberEmails = [
				...nullSafeGetOrElse('supplierSubscriberEmails', formData, []),
				...nullSafeGetOrElse('buyerSubscriberEmails', formData, []),
			];
			const isUserSubscribed = subscriberEmails.includes(currentUser.email);

			if (!isUserSubscribed) {
				this.setState({ isPrivateLoading: true });
				addBuyerSubscribers(
					{
						id: formData.id,
						addBuyerSubscriberEmails: [currentUser.email],
					},
					formData
				)
					.then(() => this.setState({ isPrivate: true }))
					.catch((err) => message.error('Failed to make the work order private, please try again.'))
					.finally(() => {
						this.setState({ isPrivateLoading: false });
					});
			} else {
				this.setState({ isPrivate: true });
			}
		}
	};

	confirmIsPrivateModal = () => {
		this.setState({ isPrivateModalVisible: false, isPrivate: false });
	};

	cancelIsPrivateModal = () => {
		this.setState({ isPrivateModalVisible: false });
	};

	//param = {key: value}
	changeApprovalHierarchyParamCheck = (param) => {
		const { willApprovalHierarchyChange, formData, isApprovalForm, currentUser } = this.props;
		const { woChanges } = this.state;
		const changes = { ...woChanges, ...param };

		this.setState({ buttonLoading: true, pendingParam: param });
		willApprovalHierarchyChange(nullSafeGet('id', formData), changes).then((result) => {
			const quoteHierarchyChanged =
				nullSafeGetOrElse('quoteApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const quoteChanged =
				nullSafeGet('quoteApprovalChanges.hasApprovedByUsers', result) &&
				nullSafeGetOrElse('quoteApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const invoiceChanged =
				nullSafeGet('invoiceApprovalChanges.hasApprovedByUsers', result) &&
				nullSafeGetOrElse('invoiceApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const workOrderHierarchyChanged =
				nullSafeGetOrElse('workOrderApprovalChanges.changedHierarchy.length', result, 0) > 0 &&
				isApprovalForm;

			this.setState({
				nextApprovalHierarchy: quoteHierarchyChanged
					? nullSafeGet('quoteApprovalChanges.changedHierarchy.0', result)
					: undefined,
				workOrderApprovalHierarchy: workOrderHierarchyChanged
					? nullSafeGet('workOrderApprovalChanges.changedHierarchy.0', result)
					: nullSafeGet('approvalHierarchy', formData),
			});
			if (quoteChanged || invoiceChanged || workOrderHierarchyChanged) {
				this.setState({
					showApprovalHierarchyChangeModal: true,
					approvalHierarchyChanges: [
						...(quoteChanged ? ['quote'] : []),
						...(invoiceChanged ? ['invoice'] : []),
						...(workOrderHierarchyChanged ? ['work order'] : []), //doesn't matter if approvers are present or not
					],
				});
			} else {
				this.changeApprovalHierarchyParamConfirm(param)();
				this.configureNTEWarningMessage();
			}
		});
	};
	changeApprovalHierarchyParamConfirm = (param) => () => {
		const { woChanges } = this.state;
		this.confirmChange();
		this.setState({
			...param,
			showApprovalHierarchyChangeModal: false,
			buttonLoading: false,
			pendingParam: undefined,
			woChanges: { ...woChanges, ...param },
		});
		this.configureNTEWarningMessage();
	};
	changeApprovalHierarchyParamDismiss = () => {
		this.cancelChange();
		this.configureNTEWarningMessage();
		this.setState({
			showApprovalHierarchyChangeModal: false,
			buttonLoading: false,
			pendingParam: undefined,
			nextApprovalHierarchy: undefined,
		});
	};

	render() {
		const {
			isApprovalForm,
			updating,
			form,
			formData,
			locations,
			areas,
			problemTypes,
			workOrderPriorities,
			currentUser,
			fetchLocations,
			fetchMultipleLocations,
			fetchAreas,
			fetchMultipleAreas,
			fetchProblemTypes,
			fetchMultipleProblemTypes,
			fetchProjects,
			fetchMultipleProjects,
			fetchWorkOrderPriorities,
			fetchMultipleWorkOrderPriorities,
			supplierFacilities,
			fetchSupplierFacilitiesInPrivateNetwork,
			fetchMultipleSupplierFacilitiesInPrivateNetwork,
			projects,
			resolutionTypes,
			fetchMultipleResolutionTypes,
			fetchResolutionTypes,
			companyConfig,
		} = this.props;
		const { getFieldDecorator, getFieldValue } = form;
		const {
			previewVisible,
			previewImage,
			supplier,
			location,
			currentNTE,
			locationNTE,
			exchangeRate,
			currencyExchangeRateBuyerToLocation,
			hasQuote,
			isCapex,
		} = this.state;
		const dateFormat = 'dddd, MMM D, YYYY, h:mm A';
		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };
		const submitLabel = isApprovalForm ? 'Approve work order' : 'Update work order';
		const isAdmin = currentUser.roles.some((role) => BUYER_ADMIN_ONLY.has(role));
		const { userApprovalInfo } = this.state;
		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier });
		const workOrderCurrency = getCurrency({ workOrder: formData });
		const resolutionsFetching = nullSafeGet('fetching', resolutionTypes);
		const hasResolutionTypes = resolutionsFetching
			? true
			: getObjectValues(nullSafeGetOrElse('records', resolutionTypes, {})).length > 0;
		getFieldDecorator('id', { initialValue: formData.id });
		getFieldDecorator('createdAt', { initialValue: formData.createdAt });
		getFieldDecorator('notes', { initialValue: formData.notes });
		getFieldDecorator('buyerCompanyId', {
			initialValue: formData.buyerCompanyId || nullSafeGet('facility.buyerCompanyId', currentUser),
		});
		getFieldDecorator('createdBy', {
			initialValue: formData.createdBy || nullSafeGet('email', currentUser),
		});
		getFieldDecorator('contractorDetails', {
			initialValue: formData.contractorDetails || {
				contractorContacts: [],
			},
		});

		getFieldDecorator('problemTypeId', {
			initialValue: formData.problemTypeId,
		});
		getFieldDecorator('isCapex', {
			initialValue: formData.isCapex,
		});
		getFieldDecorator('buyerProjectIds', {
			initialValue: formData.buyerProjectIds,
		});

		getFieldDecorator('buyerAttachments', { initialValue: formData.buyerAttachments || [] });
		getFieldDecorator('supplierAttachments', { initialValue: formData.supplierAttachments || [] });
		const calculatedDueDate = formData.dueDate ? moment(formData.dueDate) : this.calculateDueDate();
		getFieldDecorator('dueDate', { initialValue: calculatedDueDate });

		const isStoreAssociate = nullSafeGetOrElse('roles', currentUser, []).includes(
			BUYER_STORE_ASSOCIATE
		);

		const poEntryEnabled = getConfigValueDefaultingToTrue(
			companyConfig,
			'config.workOrder',
			'allowPONUmberEntry'
		);

		const areaFilterAllowed = this.isAreaFilterAllowed();
		const isImageUploading = (getFieldValue('images') || []).some((_) => _.status === 'uploading');

		//TODO: UPGRADE FORM
		return (
			<Form layout="vertical" onSubmit={this.handleSubmit} className="supplierForm">
				<ClearErrors actionCreators={WORK_ORDERS_CRUD_ACTION_CREATORS} />
				<Form.Item label="Title">
					{getFieldDecorator('title', {
						initialValue: formData.title,
						rules: [{ required: true, message: 'This field is required.' }],
					})(<Input style={{ maxWidth: 800 }} disabled={true} />)}
				</Form.Item>
				<Form.Item label="Incident Location">
					{getFieldDecorator('locationId', {
						initialValue: formData.locationId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<OWAsyncSelect
							style={{ maxWidth: 800 }}
							disabled={true}
							disabledPlaceholder={formData.locationId}
							stateSlice={locations}
							targetCollectionName={WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleLocations(ids, targetCollectionName);
							}}
							onChange={this.handleLocationChange}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) => {
								fetchLocations(
									{ name: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(location) => (
								<Select.Option key={location.id} value={location.id}>
									{location.name}
								</Select.Option>
							)}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				<Form.Item label="Area">
					{getFieldDecorator('areaId', {
						initialValue: formData.areaId,
					})(
						<ProblemTypeTreeSelect
							style={{ maxWidth: 800 }}
							targetCollectionName={WORK_ORDER_FORM_AREAS_AUTOCOMPLETE}
							stateSlice={areas}
							allowClear
							fetchMultiple={fetchMultipleAreas}
							fetchData={fetchAreas}
							renderRecord={(area) => (
								<Select.Option key={area.id} value={area.id}>
									{area.name}
								</Select.Option>
							)}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
							additionalFilters={{
								locationId: nullSafeGet('locationId', this.state),
								brandId: nullSafeGet('location.brandId', this.state),
								problemTypeId: nullSafeGet('problemTypeId', this.state),
							}}
						/>
					)}
				</Form.Item>
				<Form.Item required={true} label="Problem Type">
					{getFieldDecorator('problemTypeId', {
						initialValue: formData.problemTypeId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<ProblemTypeTreeSelect
							style={{ maxWidth: 800 }}
							mode="default"
							stateSlice={problemTypes}
							targetCollectionName={WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleProblemTypes(ids, targetCollectionName);
							}}
							onChange={this.handleProblemTypeChange}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) =>
								fetchProblemTypes(
									{ name: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								)
							}
							additionalFilters={{
								locationId: nullSafeGet('locationId', this.state),
								industryId: nullSafeGetOrElse('industryId', this.state, 1),
								brandId: nullSafeGet('location.brandId', this.state),
							}}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>

				<Form.Item label="Affected Asset">
					{getFieldDecorator('assetId', {
						initialValue: formData.assetId,
					})(
						<AssetWorkOrderSelect
							onChange={this.handleAssetChange}
							additionalFilters={{
								locationId: nullSafeGetOrElse('locationId', this.state, formData.locationId),
								problemTypeId: nullSafeGetOrElse(
									'problemTypeId',
									this.state,
									formData.problemTypeId
								),
								...(areaFilterAllowed &&
									nullSafeGetOrElse('areaId', this.state, formData.areaId) && {
										areaIdOrNull: nullSafeGetOrElse('areaId', this.state, formData.areaId),
									}),
							}}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>

				{nullSafeGetOrElse('subAssetCount', this.state.asset, 0) > 0 && (
					<Form.Item label="Sub Assets">
						{form.getFieldDecorator('subAssetIds', {
							initialValue: Array.isArray(formData.subAssetIds) ? formData.subAssetIds : [],
						})(
							<SubAssetMultiSelect
								parentAssetId={parseInt(this.state.assetId, 10)}
								fetchSubAssets={this.props.fetchSubAssets}
							/>
						)}
					</Form.Item>
				)}

				{nullSafeGet('assetId', formData) && (
					<Form.Item label="Is the asset functioning?">
						{form.getFieldDecorator('isAssetDown', {
							initialValue: formData.isAssetDown ? 'true' : 'false',
						})(
							<OWRadioGroup
								disabled
								valueAccessor={(item) => item.value}
								renderRecord={(item) => item.label}
								items={[
									{
										label: 'Yes',
										value: 'false',
									},
									{
										label: 'No',
										value: 'true',
									},
								]}
							/>
						)}
					</Form.Item>
				)}

				<Form.Item label="Additional Info">
					{getFieldDecorator('additionalInfo', {
						initialValue: formData.description,
					})(
						<OWRichTextEditor
							initialEditorState={formData.description}
							editorRef={this.state.editorRef}
						/>
					)}
				</Form.Item>
				<Form.Item label="Photos">
					{getFieldDecorator(`images`, {
						valuePropName: 'fileList',
						getValueFromEvent: normFile,
						initialValue: this.state.allPhotos,
					})(
						<OWUpload
							accept={imageWildcardUploadAccept}
							name="file"
							listType="picture-card"
							className="workorder-image-uploader"
							multiple={true}
							headers={uploadHeaders}
							onPreview={this.handlePreview}
							action={`${BACKEND_URI}/api/v1/buyer/file/upload`}
							beforeUpload={imageUploadValidation}
							onChange={this.handleImageUpdate}
						>
							<div style={{ display: 'inline' }}>
								<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
								<div className="ant-upload-text">Upload</div>
							</div>
							<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
								<ResolvedImage
									url={previewImage || ''}
									style={{ width: '100%', objectFit: 'contain' }}
									preview={false}
								/>
							</Modal>
						</OWUpload>
					)}
				</Form.Item>
				<div className={'flex flex-row'}>
					<Form.Item
						label="NTE"
						validateStatus={userApprovalInfo.status}
						help={
							userApprovalInfo.status ? (
								<div
									style={{ width: 1000 }}
									className={'absolute flex flex-row flex-nowrap'}
								>{`This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto ${locationCurrency.format(
									userApprovalInfo.amount * currencyExchangeRateBuyerToLocation
								)}`}</div>
							) : this.state.invoiceDisallowsNTE ? (
								<div style={{ width: 1000 }} className={'absolute flex flex-row flex-nowrap'}>
									{'The NTE cannot be changed while an invoice exists and is not disputed.'}
								</div>
							) : (
								''
							)
						}
						extra={
							nullSafeGet('supplier.status', this.state) === 'private' ? (
								<div className="mt-2 text-xs text-gray-500">
									NTE cannot be set for an internal team
								</div>
							) : null
						}
					>
						{getFieldDecorator('nteInLocationCurrency', {
							initialValue: locationNTE,
							validateTrigger: 'onChange',
							rules: [
								{
									validator: (rule, value, callback) => {
										if (
											userApprovalInfo.amount &&
											parseFloat(value) / currencyExchangeRateBuyerToLocation >
												parseFloat(userApprovalInfo.amount) &&
											parseFloat(value) / currencyExchangeRateBuyerToLocation !== formData.nte
										) {
											this.setState({
												userApprovalInfo: {
													...userApprovalInfo,
													status: isAdmin ? 'warning' : 'error',
												},
											});
											callback(isAdmin ? undefined : '');
										} else {
											this.setState({
												userApprovalInfo: {
													...userApprovalInfo,
													status: null,
												},
											});
											callback();
										}
									},
								},
							],
						})(
							<InputNumber
								style={{ width: 200 }}
								disabled={
									nullSafeGet('supplier.status', this.state) === 'private' ||
									isStoreAssociate ||
									this.state.invoiceDisallowsNTE
								}
								addonAfter={locationCurrency.id}
								onChange={(value) =>
									this.setState({
										locationNTE: value,
										currentNTE: (value as any) * exchangeRate,
									})
								}
							/>
						)}
					</Form.Item>
					{supplierCurrency && locationCurrency && supplierCurrency.id !== locationCurrency.id ? (
						<div className="flex flex-row" style={{ marginTop: 30 }}>
							<i
								className="icons8-font icons8-data-transfer"
								style={{ fontSize: 24, marginTop: 2, marginRight: 26 }}
							/>
							<InputNumber
								style={{ width: 200, height: 38 }}
								disabled={true}
								value={currentNTE.toFixed(2)}
								addonAfter={hasQuote ? workOrderCurrency.id : supplierCurrency.id}
							/>
						</div>
					) : null}
				</div>
				<ApprovalHierarchyChangeModal
					visible={this.state.showApprovalHierarchyChangeModal}
					onOk={this.changeApprovalHierarchyParamConfirm}
					param={this.state.pendingParam}
					onCancel={this.changeApprovalHierarchyParamDismiss}
					approvalHierarchyChanges={this.state.approvalHierarchyChanges}
				/>
				<Form.Item label="Expense Type">
					{getFieldDecorator('isCapex', {
						initialValue: formData.isCapex ? 'true' : 'false',
					})(
						<Row>
							<Spin spinning={this.state.buttonLoading}>
								<Radio.Group value={isCapex} style={{ display: 'flex' }}>
									{isCapex === false ? (
										<Radio.Button style={{ flexWrap: 'nowrap' }} value={false} onClick={() => {}}>
											R&M
										</Radio.Button>
									) : (
										<Radio.Button
											style={{ flexWrap: 'nowrap' }}
											value={false}
											onClick={() => this.changeApprovalHierarchyParamCheck({ isCapex: false })}
										>
											R&M
										</Radio.Button>
									)}
									{isCapex === true ? (
										<Radio.Button style={{ flexWrap: 'nowrap' }} value={true} onClick={() => {}}>
											CapEx
										</Radio.Button>
									) : (
										<Radio.Button
											style={{ flexWrap: 'nowrap' }}
											value={true}
											onClick={() => this.changeApprovalHierarchyParamCheck({ isCapex: true })}
										>
											CapEx
										</Radio.Button>
									)}
								</Radio.Group>
							</Spin>
							<Popover
								content={
									<div>
										<Row>
											<span style={{ fontSize: '20px' }}>Repair and Maintenance (R&M)</span>
										</Row>
										<Row>
											<span>Costs associated with repair and maintenance of existing assets</span>
										</Row>
										<Row style={{ height: '20px' }}></Row>
										<Row>
											<span style={{ fontSize: '20px' }}>Capital Expenditures (CapEx)</span>
										</Row>
										<Row>
											<span>
												Costs associated with buying new assets or upgrading existing assets
											</span>
										</Row>
									</div>
								}
							>
								<InfoCircleOutlined
									style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}
								/>
							</Popover>
						</Row>
					)}
				</Form.Item>
				<WorkOrderIsPrivateFormItem
					form={form}
					currentUser={currentUser}
					workOrder={formData}
					isPrivate={this.state.isPrivate}
					isPrivateModalVisible={this.state.isPrivateModalVisible}
					isPrivateLoading={this.state.isPrivateLoading}
					toggleIsPrivate={this.toggleIsPrivate}
					confirmIsPrivateModal={this.confirmIsPrivateModal}
					cancelIsPrivateModal={this.cancelIsPrivateModal}
				/>
				<Form.Item label="Priority">
					{getFieldDecorator('workOrderPriorityId', {
						initialValue: formData.woPriorityId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<OWAsyncSelect
							style={{ maxWidth: 800 }}
							disabled={true}
							disabledPlaceholder={formData.woPriorityId}
							stateSlice={workOrderPriorities}
							targetCollectionName={WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleWorkOrderPriorities(ids, targetCollectionName);
							}}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting = {
									sort_by: 'expectedResolutionInSeconds',
									order: 'descend',
								},
								filters,
								addToTargetCollection
							) => {
								fetchWorkOrderPriorities(
									{ name: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(workOrderPriority) => (
								<Select.Option key={workOrderPriority.id} value={workOrderPriority.id}>
									{workOrderPriority.name}
								</Select.Option>
							)}
						/>
					)}
				</Form.Item>
				<Form.Item required={true} label="Service Provider">
					{getFieldDecorator('supplierFacilityId', {
						initialValue: formData.supplierFacilityId,
					})(
						<SupplierSelectionWorkOrderSelect
							style={{ maxWidth: 800 }}
							disabled={true}
							disabledPlaceholder={formData.supplierFacilityId}
							allowClear={true}
							stateSlice={supplierFacilities}
							targetCollectionName={
								WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE
							}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleSupplierFacilitiesInPrivateNetwork(ids, targetCollectionName);
							}}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) =>
								fetchSupplierFacilitiesInPrivateNetwork(
									{ name: searchText, offset: 0, limit: 100 },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								)
							}
							onChange={this.handleSupplierFacilityChange}
							additionalFilters={{
								problemTypeId: this.state.problemTypeId,
								locationId: this.state.locationId,
							}}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				<Form.Item label="Due date">
					{getFieldDecorator('dueDate', {
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<DatePicker
							style={{ width: 300 }}
							format={dateFormat}
							showTime={true}
							disabled={true}
						/>
					)}
				</Form.Item>
				{poEntryEnabled ? (
					<Form.Item label="PO Number">
						{getFieldDecorator('poNumber', {
							initialValue: formData.poNumber,
						})(<Input style={{ maxWidth: 300 }} />)}
					</Form.Item>
				) : null}
				<Form.Item label="Project">
					{getFieldDecorator('buyerProjectIds', {
						initialValue: formData.buyerProjectIds,
					})(
						<OWAsyncSelect
							style={{ maxWidth: 800 }}
							mode={'multiple'}
							stateSlice={projects}
							targetCollectionName={WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleProjects(ids, targetCollectionName);
							}}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) => {
								fetchProjects(
									{ search: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(project) => (
								<Select.Option key={project.id} value={project.id}>
									{project.title}
								</Select.Option>
							)}
						/>
					)}
				</Form.Item>
				{hasResolutionTypes ? (
					<Form.Item label="Resolution Type">
						{getFieldDecorator('resolutionType', {
							initialValue: formData.resolutionTypeId,
						})(
							<OWAsyncSelect
								style={{ maxWidth: 800 }}
								stateSlice={resolutionTypes}
								targetCollectionName={'RESOLUTION_TYPES_AUTOCOMPLETE'}
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleResolutionTypes(ids, targetCollectionName);
								}}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchResolutionTypes(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(resolutionType) => (
									<Select.Option key={resolutionType.id} value={resolutionType.id}>
										{resolutionType.resolutionCode ? `${resolutionType.resolutionCode} - ` : null}
										{resolutionType.resolutionType}
									</Select.Option>
								)}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
								allowClear
							/>
						)}
					</Form.Item>
				) : null}
				{getFieldDecorator('status', {
					initialValue: formData.status,
				})}
				<Form.Item>
					<OWButton
						type="primary"
						htmlType="submit"
						loading={updating || isImageUploading}
						className="contactForm__button"
					>
						{submitLabel}
					</OWButton>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,
	isApprovalForm: ownProps.isApprovalForm,
	createErrors: state.work_orders.createErrors,
	updateErrors: state.work_orders.updateErrors,
	formData: ownProps.formData,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
	locations: state.locations,
	areas: state.areas,
	problemTypes: state.problem_types,
	spendCategories: state.spend_categories,
	workOrderPriorities: state.work_order_priorities,
	projects: state.projects,
	supplierFacilities: state.supplier_facilities,
	currentUser: state.session.currentUser,
	resolutionTypes: state.resolution_types,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch) => ({
	fetchAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
	fetchSubAssets: (parentId) =>
		dispatch(
			assetsRestReadThunk(
				ROLE_TYPES.BUYER,
				{ parentIds: parentId },
				SUB_ASSETS_TARGET_COLLECTION,
				{ current: 1, pageSize: 1000 },
				{ sort_by: 'name', order: 'ascend' }
			)
		),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForBuyer.readLite(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleResolutionTypes: (ids, targetCollectionName) =>
		dispatch(resolutionTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchResolutionTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			resolutionTypesRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchBuyer: (id) => dispatch(buyersRestCrudThunksForBuyer.readOne(id)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			fetchAreasWithHeirarchy(ROLE_TYPES.BUYER)(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchMultipleProblemTypes: (ids, targetCollectionName) =>
		dispatch(problemTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			problemTypesHeirarchicalForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleSpendCategories: (ids, targetCollectionName) =>
		dispatch(spendCategoriesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchSpendCategories: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			spendCategoriesRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchWorkOrderAttributes: (params) =>
		dispatch(workOrderAttributesRestCrudThunksForBuyer.read(params)),
	fetchMultipleProjects: (ids, targetCollectionName) =>
		dispatch(projectsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchProjects: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			projectsRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
		dispatch(workOrderPrioritiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchWorkOrderPriorities: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			workOrderPrioritiesWithoutPMRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
		dispatch(
			fetchSupplierFacilitiesInPrivateNetworkForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		),
	fetchMultipleSupplierFacilitiesInPrivateNetwork: (ids, targetCollectionName) =>
		dispatch(supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	updateWorkOrderForm: (workOrder) => dispatch(workOrdersRestCrudThunksForBuyer.update(workOrder)),
	fetchSupplierFacility: (id) => dispatch(supplierFacilitiesRestCrudThunksForBuyer.readOne(id)),
	fetchSupplierCompany: (id) => dispatch(suppliersRestCrudThunksForBuyer.readOne(id)),
	fetchExchangeRate: (c1, c2, userType) => dispatch(getExchangeRate(c1, c2)(userType)),
	getQuotes: (params, targetCollectionName) =>
		dispatch(proposalsRestCrudThunksForBuyer.read(params, targetCollectionName)),
	getApprovalHierarchy: (params) =>
		dispatch(getProposalApprovalHierarchiesByAttributes('buyer', params)),
	willApprovalHierarchyChange: (workOrderId, params) =>
		dispatch(hasApprovalHierarchyChanged('buyer', workOrderId, params)),
	fetchApprovalHeirarchy: (id) => dispatch(getBuyerCompanyApprovalTiers(ROLE_TYPES.BUYER, null)()),
	fetchLocation: (id) => dispatch(locationsRestCrudThunksForBuyer.readOne(id)),
	getInvoiceCounts: (params) =>
		dispatch(invoicesRestCrudThunksForBuyer.countBy(params, 'invoice_counts')),
	addBuyerSubscribers: (obj, workOrder) => dispatch(addBuyerSubscribersForBuyers(obj)(workOrder)),
});

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Form.create<WorkOrderSafeFormProps>()(WorkOrderEditSafeForm))
);
